import React from 'react';
import { MetaTags } from 'react-meta-tags';
//import Breadcrumbs
import {
  Breadcrumbs,
  DashBreadcrumb,
} from '../../components/Common/Breadcrumb';
//import OrderList from './components/orderList';
import BulkOrderList from './components/bulkorders/BulkOrderList';
import 'react-datepicker/dist/react-datepicker.css';
//Import Flatepicker
import 'flatpickr/dist/themes/material_blue.css';
import Flatpickr from 'react-flatpickr';
import OrderExportReport from './components/OrderExportReport';
import { EXPORT_ALLOWED_USER_ROLES } from '../../constants/index';
import { Col, Container, Row, FormGroup, InputGroup } from 'reactstrap';

const bulkOrders = () => {
  const users = JSON.parse(localStorage?.getItem('authUser'));
  const title = 'Orders';
  const description = 'Bulk Orders';

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Bulk Orders</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col xl={8}>
              <DashBreadcrumb title="Orders" breadcrumbItem="Bulk Orders" />
            </Col>
            {EXPORT_ALLOWED_USER_ROLES.includes(users?.role_id) ? (
              <OrderExportReport />
            ) : (
              ''
            )}
          </Row>

          <BulkOrderList />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default bulkOrders;
